import React, { useState, useEffect } from "react";
import AOS from "aos";
import Bag1 from "../Assets/Images/Portfolio/Bags/bag-design-1.avif";
import Bag2 from "../Assets/Images/Portfolio/Bags/bag-design-2.avif";
import Bag3 from "../Assets/Images/Portfolio/Bags/bag-design-3.avif";
import Bag4 from "../Assets/Images/Portfolio/Bags/bag-design-4.avif";
import Bag5 from "../Assets/Images/Portfolio/Bags/bag-design-5.avif";
import Bag6 from "../Assets/Images/Portfolio/Bags/bag-design-6.avif";
import Bag7 from "../Assets/Images/Portfolio/Bags/bag-design-7.avif";
import Bag8 from "../Assets/Images/Portfolio/Bags/bag-design-8.avif";
import Bag9 from "../Assets/Images/Portfolio/Bags/bag-design-9.avif";
import Bag10 from "../Assets/Images/Portfolio/Bags/bag-design-10.avif";
import Bag11 from "../Assets/Images/Portfolio/Bags/bag-design-11.avif";
import Bag12 from "../Assets/Images/Portfolio/Bags/bag-design-12.avif";
import Ceramics1 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-1.avif";
import Ceramics2 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-2.avif";
import Ceramics3 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-3.avif";
import Ceramics4 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-4.avif";
import Ceramics5 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-5.avif";
import Ceramics6 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-6.avif";
import Ceramics7 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-7.avif";
import Ceramics8 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-8.avif";
import Ceramics9 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-9.avif";
import Ceramics10 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-10.avif";
import Ceramics11 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-11.avif";
import Ceramics12 from "../Assets/Images/Portfolio/Ceramics/ceramics-design-12.avif";
import Crockery1 from "../Assets/Images/Portfolio/Crockery/crockery-1.avif";
import Crockery2 from "../Assets/Images/Portfolio/Crockery/crockery-2.avif";
import Crockery3 from "../Assets/Images/Portfolio/Crockery/crockery-3.avif";
import Crockery4 from "../Assets/Images/Portfolio/Crockery/crockery-4.avif";
import Crockery5 from "../Assets/Images/Portfolio/Crockery/crockery-5.avif";
import Crockery6 from "../Assets/Images/Portfolio/Crockery/crockery-6.avif";
import Crockery7 from "../Assets/Images/Portfolio/Crockery/crockery-7.avif";
import Crockery8 from "../Assets/Images/Portfolio/Crockery/crockery-8.avif";
import Crockery9 from "../Assets/Images/Portfolio/Crockery/crockery-9.avif";
import Crockery10 from "../Assets/Images/Portfolio/Crockery/crockery-10.avif";
import Crockery11 from "../Assets/Images/Portfolio/Crockery/crockery-11.avif";
import Crockery12 from "../Assets/Images/Portfolio/Crockery/crockery-12.avif";
import GA1 from "../Assets/Images/Portfolio/Give-Aways/GA-1.avif";
import GA2 from "../Assets/Images/Portfolio/Give-Aways/GA-2.avif";
import GA3 from "../Assets/Images/Portfolio/Give-Aways/GA-3.avif";
import GA4 from "../Assets/Images/Portfolio/Give-Aways/GA-4.avif";
import GA5 from "../Assets/Images/Portfolio/Give-Aways/GA-5.avif";
import GA6 from "../Assets/Images/Portfolio/Give-Aways/GA-6.avif";
import GA7 from "../Assets/Images/Portfolio/Give-Aways/GA-7.avif";
import GA8 from "../Assets/Images/Portfolio/Give-Aways/GA-8.avif";
import GA9 from "../Assets/Images/Portfolio/Give-Aways/GA-9.avif";
import GA10 from "../Assets/Images/Portfolio/Give-Aways/GA-10.avif";
import GA11 from "../Assets/Images/Portfolio/Give-Aways/GA-11.avif";
import GA12 from "../Assets/Images/Portfolio/Give-Aways/GA-12.avif";
import Logo1 from "../Assets/Images/Portfolio/Logos/Logo-1.avif";
import Logo2 from "../Assets/Images/Portfolio/Logos/Logo-2.avif";
import Logo3 from "../Assets/Images/Portfolio/Logos/Logo-3.avif";
import Logo4 from "../Assets/Images/Portfolio/Logos/Logo-4.avif";
import Logo5 from "../Assets/Images/Portfolio/Logos/Logo-5.avif";
import Logo6 from "../Assets/Images/Portfolio/Logos/Logo-6.avif";
import Logo7 from "../Assets/Images/Portfolio/Logos/Logo-7.avif";
import Logo8 from "../Assets/Images/Portfolio/Logos/Logo-8.avif";
import Logo9 from "../Assets/Images/Portfolio/Logos/Logo-9.avif";
import Logo10 from "../Assets/Images/Portfolio/Logos/Logo-10.avif";
import Logo11 from "../Assets/Images/Portfolio/Logos/Logo-11.avif";
import Logo12 from "../Assets/Images/Portfolio/Logos/Logo-12.avif";
import Menu1 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-1.avif";
import Menu2 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-2.avif";
import Menu3 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-3.avif";
import Menu4 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-4.avif";
import Menu5 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-5.avif";
import Menu6 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-6.avif";
import Menu7 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-7.avif";
import Menu8 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-8.avif";
import Menu9 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-9.avif";
import Menu10 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-10.avif";
import Menu11 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-11.avif";
import Menu12 from "../Assets/Images/Portfolio/Restaurant & Cafe Menus/menu-12.avif";
import RE1 from "../Assets/Images/Portfolio/Real Estate/RE-1.avif";
import RE2 from "../Assets/Images/Portfolio/Real Estate/RE-2.avif";
import RE3 from "../Assets/Images/Portfolio/Real Estate/RE-3.avif";
import RE4 from "../Assets/Images/Portfolio/Real Estate/RE-4.avif";
import RE5 from "../Assets/Images/Portfolio/Real Estate/RE-5.avif";
import RE6 from "../Assets/Images/Portfolio/Real Estate/RE-6.avif";
import RE7 from "../Assets/Images/Portfolio/Real Estate/RE-7.avif";
import RE8 from "../Assets/Images/Portfolio/Real Estate/RE-8.avif";
import RE9 from "../Assets/Images/Portfolio/Real Estate/RE-9.avif";
import RE10 from "../Assets/Images/Portfolio/Real Estate/RE-10.avif";
import RE11 from "../Assets/Images/Portfolio/Real Estate/RE-11.avif";
import RE12 from "../Assets/Images/Portfolio/Real Estate/RE-12.avif";
import Sanitary1 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-1.avif";
import Sanitary2 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-2.avif";
import Sanitary3 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-3.avif";
import Sanitary4 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-4.avif";
import Sanitary5 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-5.avif";
import Sanitary6 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-6.avif";
import Sanitary7 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-7.avif";
import Sanitary8 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-8.avif";
import Sanitary9 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-9.avif";
import Sanitary10 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-10.avif";
import Sanitary11 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-11.avif";
import Sanitary12 from "../Assets/Images/Portfolio/Sanitary Industry/sanitary-12.avif";
import Suitbox1 from "../Assets/Images/Portfolio/Suitbox/suitbox-1.avif";
import Suitbox2 from "../Assets/Images/Portfolio/Suitbox/suitbox-2.avif";
import Suitbox3 from "../Assets/Images/Portfolio/Suitbox/suitbox-3.avif";
import Suitbox4 from "../Assets/Images/Portfolio/Suitbox/suitbox-4.avif";
import Suitbox5 from "../Assets/Images/Portfolio/Suitbox/suitbox-5.avif";
import Suitbox6 from "../Assets/Images/Portfolio/Suitbox/suitbox-6.avif";
import Suitbox7 from "../Assets/Images/Portfolio/Suitbox/suitbox-7.avif";
import Suitbox8 from "../Assets/Images/Portfolio/Suitbox/suitbox-8.avif";
import Suitbox9 from "../Assets/Images/Portfolio/Suitbox/suitbox-9.avif";
import Suitbox10 from "../Assets/Images/Portfolio/Suitbox/suitbox-10.avif";
import Suitbox11 from "../Assets/Images/Portfolio/Suitbox/suitbox-11.avif";
import Suitbox12 from "../Assets/Images/Portfolio/Suitbox/suitbox-12.avif";
import Sweetbox1 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-1.avif";
import Sweetbox2 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-2.avif";
import Sweetbox3 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-3.avif";
import Sweetbox4 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-4.avif";
import Sweetbox5 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-5.avif";
import Sweetbox6 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-6.avif";
import Sweetbox7 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-7.avif";
import Sweetbox8 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-8.avif";
import Sweetbox9 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-9.avif";
import Sweetbox10 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-10.avif";
import Sweetbox11 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-11.avif";
import Sweetbox12 from "../Assets/Images/Portfolio/Sweetbox/sweetbox-12.avif";

function WorkTabs() {
  useEffect(() => {
    AOS.init();
  }, []);

  const [activeTab, setActiveTab] = useState("bags-design");
  const [showImage, setShowImage] = useState();

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const handleImage = (image) => {
    setShowImage(image);
  };

  
  

  return (
    <div>
      <section
        className="pills-tab-section mt-5 "
        style={{ scrollMarginTop: "65px", backgroundColor: "#f5f5f5" }}
      >
        <div className="container-fluid px-4 py-4">
          <div className="row">
            <div
              className="col-md-3 jutify-content-center align-items-center"
              data-aos="fade-right"
              data-aos-duration="2000"
            >
              {/* Tab navs */}
              <div
                className="nav flex-column nav-pills text-start"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <a
                  className={`nav-link mb-2 ${
                    activeTab === "bags-design" ? "active" : ""
                  }`}
                  id="bags-design-tab"
                  data-mdb-toggle="pill"
                  href="#bags-design"
                  role="tab"
                  onClick={() => handleTabChange("bags-design")}
                  aria-controls="bags-design"
                  aria-selected={activeTab === "bags-design"}
                  style={{
                    fontWeight: "bold",
                    borderRadius: "25px 0",
                    display: "block",
                    padding: "12px",
                    backgroundColor:
                      activeTab === "bags-design"
                        ? "var(--primary-color)"
                        : "transparent",
                    color:
                      activeTab === "bags-design"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "bags-design"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  <span className="mt-3">Bags Designs</span>
                </a>

                <a
                  className={`nav-link mb-2 ${
                    activeTab === "ceramics-industry" ? "active" : ""
                  }`}
                  id="ceramics-industry-tab"
                  data-mdb-toggle="pill"
                  href="#ceramics-industry"
                  role="tab"
                  onClick={() => handleTabChange("ceramics-industry")}
                  aria-controls="ceramics-industry"
                  aria-selected={activeTab === "ceramics-industry"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    padding: "12px",
                    borderRadius: "25px 0",
                    backgroundColor:
                      activeTab === "ceramics-industry"
                        ? "var(--primary-color)"
                        : "transparent",
                    color:
                      activeTab === "ceramics-industry"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "ceramics-industry"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  Services For Ceramics Industry
                </a>

                <a
                  className={`nav-link mb-2 ${
                    activeTab === "crockery-packaging" ? "active" : ""
                  }`}
                  id="crockery-packaging-tab"
                  data-mdb-toggle="pill"
                  href="#crockery-packaging"
                  role="tab"
                  onClick={() => handleTabChange("crockery-packaging")}
                  aria-controls="crockery-packaging"
                  aria-selected={activeTab === "crockery-packaging"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    padding: "12px",
                    borderRadius: "25px 0",
                    backgroundColor:
                      activeTab === "crockery-packaging"
                        ? "var(--primary-color)"
                        : "transparent",
                    color:
                      activeTab === "crockery-packaging"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "crockery-packaging"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  Crockery Packaging
                </a>

                <a
                  className={`nav-link mb-2 ${
                    activeTab === "give-aways" ? "active" : ""
                  }`}
                  id="give-aways-tab"
                  data-mdb-toggle="pill"
                  href="#give-aways"
                  role="tab"
                  onClick={() => handleTabChange("give-aways")}
                  aria-controls="crockery-packaging"
                  aria-selected={activeTab === "give-aways"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    padding: "12px",
                    borderRadius: "25px 0",
                    backgroundColor:
                      activeTab === "give-aways"
                        ? "var(--primary-color)"
                        : "transparent",
                    color:
                      activeTab === "give-aways"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "give-aways"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  Give Aways
                </a>

                <a
                  className={`nav-link mb-2 ${
                    activeTab === "logos-design" ? "active" : ""
                  }`}
                  id="logos-design-tab"
                  data-mdb-toggle="pill"
                  href="#logos-design"
                  role="tab"
                  onClick={() => handleTabChange("logos-design")}
                  aria-controls="logos-design"
                  aria-selected={activeTab === "logos-design"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    padding: "12px",
                    borderRadius: "25px 0",
                    backgroundColor:
                      activeTab === "logos-design"
                        ? "var(--primary-color)"
                        : "transparent",
                    color:
                      activeTab === "logos-design"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "logos-design"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  Logos Design
                </a>

                <a
                  className={`nav-link mb-2  ${
                    activeTab === "restaurants-and-cafe" ? "active" : ""
                  }`}
                  id="restaurants-and-cafe-tab"
                  data-mdb-toggle="pill"
                  href="#restaurants-and-cafe"
                  role="tab"
                  onClick={() => handleTabChange("restaurants-and-cafe")}
                  aria-controls="restaurants-and-cafe"
                  aria-selected={activeTab === "restaurants-and-cafe"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    padding: "12px",
                    borderRadius: "25px 0",
                    backgroundColor:
                      activeTab === "restaurants-and-cafe"
                        ? "var(--primary-color)"
                        : "transparent",

                    color:
                      activeTab === "restaurants-and-cafe"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "restaurants-and-cafe"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  Restaurants & Cafe Menus
                </a>

                <a
                  className={`nav-link mb-2  ${
                    activeTab === "real-estate-industry" ? "active" : ""
                  }`}
                  id="real-estate-industry-tab"
                  data-mdb-toggle="pill"
                  href="#real-estate-industry"
                  role="tab"
                  onClick={() => handleTabChange("real-estate-industry")}
                  aria-controls="real-estate-industry"
                  aria-selected={activeTab === "real-estate-industry"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    padding: "12px",
                    borderRadius: "25px 0",
                    backgroundColor:
                      activeTab === "real-estate-industry"
                        ? "var(--primary-color)"
                        : "transparent",
                    color:
                      activeTab === "real-estate-industry"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "real-estate-industry"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  Real Estate Industry
                </a>

                <a
                  className={`nav-link mb-2  ${
                    activeTab === "sanitary-industry" ? "active" : ""
                  }`}
                  id="sanitary-industry-tab"
                  data-mdb-toggle="pill"
                  href="#sanitary-industry"
                  role="tab"
                  onClick={() => handleTabChange("sanitary-industry")}
                  aria-controls="sanitary-industry"
                  aria-selected={activeTab === "sanitary-industry"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    padding: "12px",
                    borderRadius: "25px 0",
                    backgroundColor:
                      activeTab === "sanitary-industry"
                        ? "var(--primary-color)"
                        : "transparent",
                    color:
                      activeTab === "sanitary-industry"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "sanitary-industry"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  Sanitary Industry
                </a>

                <a
                  className={`nav-link mb-2  ${
                    activeTab === "suit-box" ? "active" : ""
                  }`}
                  id="suit-box-tab"
                  data-mdb-toggle="pill"
                  href="#suit-box"
                  role="tab"
                  onClick={() => handleTabChange("suit-box")}
                  aria-controls="suit-box"
                  aria-selected={activeTab === "suit-box"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    padding: "12px",
                    borderRadius: "25px 0",
                    backgroundColor:
                      activeTab === "suit-box"
                        ? "var(--primary-color)"
                        : "transparent",
                    color:
                      activeTab === "suit-box"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "suit-box"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  Suit Box
                </a>

                <a
                  className={`nav-link mb-2  ${
                    activeTab === "sweets-box" ? "active" : ""
                  }`}
                  id="sweets-box-tab"
                  data-mdb-toggle="pill"
                  href="#sweets-box"
                  role="tab"
                  onClick={() => handleTabChange("sweets-box")}
                  aria-controls="sweets-box"
                  aria-selected={activeTab === "sweets-box"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    padding: "12px",
                    borderRadius: "25px 0",
                    backgroundColor:
                      activeTab === "sweets-box"
                        ? "var(--primary-color)"
                        : "transparent",
                    color:
                      activeTab === "sweets-box"
                        ? "#fff"
                        : "var(--primary-color)",
                    border:
                      activeTab === "sweets-box"
                        ? "none"
                        : "1px solid var(--primary-color)",
                  }}
                >
                  Sweets Box
                </a>
              </div>
              {/* Tab navs  */}
            </div>

            <div
              className="col-md-9 tab-detail"
              data-aos="fade-left"
              data-aos-duration="2000"
            >
              {/* Tab content */}
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className={`tab-pane fade show ${
                    activeTab === "bags-design" ? "active" : ""
                  }`}
                  id="bags-design"
                  role="tabpanel"
                  aria-labelledby="bags-design-tab"
                >
                  <div className="container bag-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={Bag1}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Bag2}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Bag3}
                          alt="bags-design"
                          onClick={() => handleImage(Bag3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Bag4}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Bag5}
                          alt="bags-design"
                          onClick={() => handleImage(Bag5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Bag6}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Bag7}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag7)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Bag8}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Bag9}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag9)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Bag10}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Bag11}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Bag12}
                          alt="bags-designs"
                          onClick={() => handleImage(Bag12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade show ${
                    activeTab === "ceramics-industry" ? "active" : ""
                  }`}
                  id="ceramics-industry"
                  role="tabpanel"
                  aria-labelledby="ceramics-industry-tab"
                >
                  <div className="container ceramics-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={Ceramics1}
                          alt="ceramics-designs-1"
                          onClick={() => handleImage(Ceramics1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Ceramics2}
                          alt="ceramics-designs-2"
                          onClick={() => handleImage(Ceramics2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Ceramics3}
                          alt="ceramics-design-3"
                          onClick={() => handleImage(Ceramics3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Ceramics4}
                          alt="ceramics-designs-4"
                          onClick={() => handleImage(Ceramics4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Ceramics5}
                          alt="ceramics-design-5"
                          onClick={() => handleImage(Ceramics5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Ceramics6}
                          alt="ceramics-designs-7"
                          onClick={() => handleImage(Ceramics6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Ceramics7}
                          alt="ceramics-designs-7"
                          onClick={() => handleImage(Ceramics7)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Ceramics8}
                          alt="ceramics-designs-8"
                          onClick={() => handleImage(Ceramics8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Ceramics9}
                          alt="ceramics-designs-9"
                          onClick={() => handleImage(Ceramics9)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Ceramics10}
                          alt="ceramics-designs-10"
                          onClick={() => handleImage(Ceramics10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Ceramics11}
                          alt="ceramics-designs-11"
                          onClick={() => handleImage(Ceramics11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Ceramics12}
                          alt="ceramics-designs-12"
                          onClick={() => handleImage(Ceramics12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade show ${
                    activeTab === "crockery-packaging" ? "active" : ""
                  }`}
                  id="crockery-packaging"
                  role="tabpanel"
                  aria-labelledby="crockery-packaging-tab"
                >
                  <div className="container ceramics-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={Crockery1}
                          alt="crockery-designs-1"
                          onClick={() => handleImage(Crockery1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Crockery2}
                          alt="crockery-designs-2"
                          onClick={() => handleImage(Crockery2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Crockery3}
                          alt="crockery-design-3"
                          onClick={() => handleImage(Crockery3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Crockery4}
                          alt="crockery-designs-4"
                          onClick={() => handleImage(Crockery4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Crockery5}
                          alt="crockery-design-5"
                          onClick={() => handleImage(Crockery5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Crockery6}
                          alt="crockery-designs-6"
                          onClick={() => handleImage(Crockery6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Crockery7}
                          alt="crockery-designs-7"
                          onClick={() => handleImage(Crockery7)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Crockery8}
                          alt="ceramics-designs-8"
                          onClick={() => handleImage(Crockery8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Crockery9}
                          alt="crockery-designs-9"
                          onClick={() => handleImage(Crockery9)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Crockery10}
                          alt="crockery-designs-10"
                          onClick={() => handleImage(Crockery10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Crockery11}
                          alt="crockery-designs-11"
                          onClick={() => handleImage(Crockery11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Crockery12}
                          alt="crockery-designs-12"
                          onClick={() => handleImage(Crockery12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade show ${
                    activeTab === "give-aways" ? "active" : ""
                  }`}
                  id="give-aways"
                  role="tabpanel"
                  aria-labelledby="give-aways"
                >
                  <div className="container ceramics-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={GA1}
                          alt="givevaway-designs-1"
                          onClick={() => handleImage(GA1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={GA2}
                          alt="giveaway-designs-2"
                          onClick={() => handleImage(GA2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={GA3}
                          alt="giveaway-design-3"
                          onClick={() => handleImage(GA3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={GA4}
                          alt="giveaway-designs-4"
                          onClick={() => handleImage(GA4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={GA5}
                          alt="giveaway-design-5"
                          onClick={() => handleImage(GA5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={GA6}
                          alt="giveaway-designs-6"
                          onClick={() => handleImage(GA6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={GA7}
                          alt="giveaway-designs-7"
                          onClick={() => handleImage(GA7)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={GA8}
                          alt="giveaway-designs-8"
                          onClick={() => handleImage(GA8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={GA9}
                          alt="giveaway-designs-9"
                          onClick={() => handleImage(GA9)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={GA10}
                          alt="giveaway-designs-10"
                          onClick={() => handleImage(GA10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={GA11}
                          alt="giveaway-designs-11"
                          onClick={() => handleImage(GA11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={GA12}
                          alt="giveaway-designs-12"
                          onClick={() => handleImage(GA12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade show ${
                    activeTab === "logos-design" ? "active" : ""
                  }`}
                  id="logos-design"
                  role="tabpanel"
                  aria-labelledby="logos-design"
                >
                  <div className="container ceramics-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={Logo1}
                          alt="logos-designs-1"
                          onClick={() => handleImage(Logo1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Logo2}
                          alt="logos-designs-2"
                          onClick={() => handleImage(Logo2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Logo3}
                          alt="logos-design-3"
                          onClick={() => handleImage(Logo3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Logo4}
                          alt="logos-designs-4"
                          onClick={() => handleImage(Logo4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Logo5}
                          alt="logos-design-5"
                          onClick={() => handleImage(Logo5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Logo6}
                          alt="logos-designs-6"
                          onClick={() => handleImage(Logo6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Logo7}
                          alt="logos-designs-7"
                          onClick={() => handleImage(Logo7)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Logo8}
                          alt="logos-designs-8"
                          onClick={() => handleImage(Logo8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Logo9}
                          alt="logos-designs-9"
                          onClick={() => handleImage(Logo9)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Logo10}
                          alt="logos-designs-10"
                          onClick={() => handleImage(Logo10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Logo11}
                          alt="logos-designs-11"
                          onClick={() => handleImage(Logo11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Logo12}
                          alt="logos-designs-12"
                          onClick={() => handleImage(Logo12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade show ${
                    activeTab === "restaurants-and-cafe" ? "active" : ""
                  }`}
                  id="restaurants-and-cafe"
                  role="tabpanel"
                  aria-labelledby="restaurants-and-cafe"
                >
                  <div className="container ceramics-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={Menu1}
                          alt="Menus-designs-1"
                          onClick={() => handleImage(Menu1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Menu2}
                          alt="Menus-designs-2"
                          onClick={() => handleImage(Menu2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Menu3}
                          alt="Menus-design-3"
                          onClick={() => handleImage(Menu3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Menu4}
                          alt="Menus-designs-4"
                          onClick={() => handleImage(Menu4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Menu5}
                          alt="Menus-design-5"
                          onClick={() => handleImage(Menu5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Menu6}
                          alt="Menus-designs-6"
                          onClick={() => handleImage(Menu6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Menu7}
                          alt="Menus-designs-7"
                          onClick={() => handleImage(Menu7)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Menu8}
                          alt="Menus-designs-8"
                          onClick={() => handleImage(Menu8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Menu9}
                          alt="Menus-designs-9"
                          onClick={() => handleImage(Menu9)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Menu10}
                          alt="Menus-designs-10"
                          onClick={() => handleImage(Menu10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Menu11}
                          alt="Menus-designs-11"
                          onClick={() => handleImage(Menu11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Menu12}
                          alt="Menus-designs-12"
                          onClick={() => handleImage(Menu12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade show ${
                    activeTab === "real-estate-industry" ? "active" : ""
                  }`}
                  id="real-estate-industry"
                  role="tabpanel"
                  aria-labelledby="real-estate-industry"
                >
                  <div className="container ceramics-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={RE1}
                          alt="REs-designs-1"
                          onClick={() => handleImage(RE1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={RE2}
                          alt="REs-designs-2"
                          onClick={() => handleImage(RE2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={RE3}
                          alt="REs-design-3"
                          onClick={() => handleImage(RE3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={RE4}
                          alt="REs-designs-4"
                          onClick={() => handleImage(RE4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={RE5}
                          alt="REs-design-5"
                          onClick={() => handleImage(RE5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={RE6}
                          alt="REs-designs-6"
                          onClick={() => handleImage(RE6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={RE7}
                          alt="REs-designs-7"
                          onClick={() => handleImage(RE7)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={RE8}
                          alt="REs-designs-8"
                          onClick={() => handleImage(RE8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={RE9}
                          alt="REs-designs-9"
                          onClick={() => handleImage(RE9)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={RE10}
                          alt="REs-designs-10"
                          onClick={() => handleImage(RE10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={RE11}
                          alt="REs-designs-11"
                          onClick={() => handleImage(RE11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={RE12}
                          alt="REs-designs-12"
                          onClick={() => handleImage(RE12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade show ${
                    activeTab === "sanitary-industry" ? "active" : ""
                  }`}
                  id="sanitary-industry"
                  role="tabpanel"
                  aria-labelledby="sanitary-industry"
                >
                  <div className="container ceramics-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={Sanitary1}
                          alt="Sanitarys-designs-1"
                          onClick={() => handleImage(Sanitary1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sanitary2}
                          alt="Sanitarys-designs-2"
                          onClick={() => handleImage(Sanitary2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Sanitary3}
                          alt="Sanitarys-design-3"
                          onClick={() => handleImage(Sanitary3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sanitary4}
                          alt="Sanitarys-designs-4"
                          onClick={() => handleImage(Sanitary4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sanitary5}
                          alt="Sanitarys-design-5"
                          onClick={() => handleImage(Sanitary5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Sanitary6}
                          alt="Sanitarys-designs-6"
                          onClick={() => handleImage(Sanitary6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sanitary7}
                          alt="Sanitarys-designs-7"
                          onClick={() => handleImage(Sanitary7)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sanitary8}
                          alt="Sanitarys-designs-8"
                          onClick={() => handleImage(Sanitary8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sanitary9}
                          alt="Sanitarys-designs-9"
                          onClick={() => handleImage(Sanitary9)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sanitary10}
                          alt="Sanitarys-designs-10"
                          onClick={() => handleImage(Sanitary10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sanitary11}
                          alt="Sanitarys-designs-11"
                          onClick={() => handleImage(Sanitary11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sanitary12}
                          alt="Sanitarys-designs-12"
                          onClick={() => handleImage(Sanitary12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade show ${
                    activeTab === "suit-box" ? "active" : ""
                  }`}
                  id="suit-box"
                  role="tabpanel"
                  aria-labelledby="suit-box"
                >
                  <div className="container ceramics-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={Suitbox1}
                          alt="Suitboxs-designs-1"
                          onClick={() => handleImage(Suitbox1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Suitbox2}
                          alt="Suitboxs-designs-2"
                          onClick={() => handleImage(Suitbox2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Suitbox3}
                          alt="Suitboxs-design-3"
                          onClick={() => handleImage(Suitbox3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Suitbox4}
                          alt="Suitboxs-designs-4"
                          onClick={() => handleImage(Suitbox4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Suitbox5}
                          alt="Suitboxs-design-5"
                          onClick={() => handleImage(Suitbox5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Suitbox6}
                          alt="Suitboxs-designs-6"
                          onClick={() => handleImage(Suitbox6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Suitbox7}
                          alt="Suitboxs-designs-7"
                          onClick={() => handleImage(Suitbox7)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Suitbox8}
                          alt="Suitboxs-designs-8"
                          onClick={() => handleImage(Suitbox8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Suitbox9}
                          alt="Suitboxs-designs-9"
                          onClick={() => handleImage(Suitbox9)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Suitbox10}
                          alt="Suitboxs-designs-10"
                          onClick={() => handleImage(Suitbox10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Suitbox11}
                          alt="Suitboxs-designs-11"
                          onClick={() => handleImage(Suitbox11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Suitbox12}
                          alt="Suitboxs-designs-12"
                          onClick={() => handleImage(Suitbox12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade show ${
                    activeTab === "sweets-box" ? "active" : ""
                  }`}
                  id="sweets-box"
                  role="tabpanel"
                  aria-labelledby="sweets-box"
                >
                  <div className="container ceramics-design-gallery">
                    <div className="row photos">
                      <div className="col-md-4  item">
                        <img
                          data-lightbox="photos"
                          className="img-fluid"
                          src={Sweetbox1}
                          alt="Sweetboxs-designs-1"
                          onClick={() => handleImage(Sweetbox1)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sweetbox2}
                          alt="Sweetboxs-designs-2"
                          onClick={() => handleImage(Sweetbox2)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className=" col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Sweetbox3}
                          alt="Sweetboxs-design-3"
                          onClick={() => handleImage(Sweetbox3)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sweetbox4}
                          alt="Sweetboxs-designs-4"
                          onClick={() => handleImage(Sweetbox4)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sweetbox5}
                          alt="Sweetboxs-design-5"
                          onClick={() => handleImage(Sweetbox5)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                      <div className="col-md-4  item">
                        <img
                          className="img-fluid"
                          src={Sweetbox6}
                          alt="Sweetboxs-designs-6"
                          onClick={() => handleImage(Sweetbox6)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sweetbox7}
                          alt="Sweetboxs-designs-7"
                          onClick={() => handleImage(Sweetbox7)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sweetbox8}
                          alt="Sweetboxs-designs-8"
                          onClick={() => handleImage(Sweetbox8)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sweetbox9}
                          alt="Sweetboxs-designs-9"
                          onClick={() => handleImage(Sweetbox9)}
                          data-bs-toggle="modal"
                          datagiveawayet="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sweetbox10}
                          alt="Sweetboxs-designs-10"
                          onClick={() => handleImage(Sweetbox10)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sweetbox11}
                          alt="Sweetboxs-designs-11"
                          onClick={() => handleImage(Sweetbox11)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>

                      <div className="col-md-4 item">
                        <img
                          className="img-fluid"
                          src={Sweetbox12}
                          alt="Sweetboxs-designs-12"
                          onClick={() => handleImage(Sweetbox12)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Tab content */}
            </div>
          </div>
        </div>
      </section>
      {/* image modal */}

      {/* <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog my-modal modal-lg">
          <div className="modal-content transparent-background">
            <div className=" d-flex justify-content-end text-light">
              <button
                type="button"
                className="btn-close bg-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <img src={showImage} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </div> */}

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog my-modal modal-lg">
          <div className="modal-content transparent-background">
            <div className="d-flex justify-content-end text-light">
              <button
                type="button"
                className="btn-close bg-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
            
              <div className="image-container">  
                <img
                  src={showImage}
                  alt=""
                  className="img-fluid"
                  id="zoomedImage"
                />
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkTabs;
